// Read-only, client-side Supabase client for the public blog.
//
// This is intentionally SEPARATE from the server-side Supabase usage in
// frontend/api/contact.js (which uses the service-role key and must never be
// exposed to the browser). The blog only needs anonymous SELECT access to
// published rows, which RLS already permits, so a publishable anon key is safe
// to ship in the CRA build.
//
// Blog posts live in the `blog` schema (table blog.posts) of the shared ANS RPO
// Supabase project — the blog was migrated out of its own standalone project.
// Setting db.schema below makes .from("posts") resolve to blog.posts, mirroring
// how api/contact.js scopes itself to the `aidify` schema in that same project.
// The project is shared with ANS RPO, so every query must keep its
// .in("site", ["aidify", "both"]) filter or ANS RPO posts would leak onto
// aidify.us.
//
// CRA only inlines env vars prefixed with REACT_APP_, so both vars below must
// use that prefix to reach the browser bundle.
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_BLOG_SUPABASE_URL;
const anonKey = process.env.REACT_APP_BLOG_SUPABASE_ANON_KEY;

// Guard against missing config: rather than throwing at import time (which would
// crash the whole route), export a null client. Pages check for this and render
// a graceful empty/error state instead.
export const blogSupabase =
  url && anonKey
    ? createClient(url, anonKey, {
        auth: { persistSession: false, autoRefreshToken: false },
        db: { schema: "blog" },
      })
    : null;

export const isBlogConfigured = Boolean(blogSupabase);
